module.exports = __webpack_public_path__ + "assets/img/rankBg.b7793763.png";